function SuccessfullyContact() {
    return ( <>
     <div className="success-page">
      <h1>Thank You For Contacting Us!</h1>
      <p>We will get back to you on your email</p>
    </div>
    </> );
}

export default SuccessfullyContact;